<template>
  <div>
    <a-modal
      v-model="isShow"
      centered
      :mask-closable="false"
      :ok-button-props="{ props: { loading: submitting } }"
      title="编辑"
      :width="640"
      @ok="handleSubmit"
    >
      <a-form
        class="simiot-compact-form"
        :form="form"
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 14 }"
        @submit="handleSubmit"
      >
        <a-form-item label="运营商">
          <a-select
            v-decorator="['carrier_type', {
              rules: [{ required: true, message: '请选择运营商' }]
            }]"
            placeholder="请选择"
            allow-clear
            @change="handleCarrierTypeChange"
          >
            <a-select-option
              v-for="option in carrierTypeOptions"
              :key="option.value"
              :value="option.value"
            >
              {{ option.label }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="场景名称">
          <a-input
            v-decorator="['name', {
              normalize: this.$lodash.trim,
              rules: [
                { required: true, message: '请输入场景名称' },
                { max: 50, message: '最多50个字符' },
              ]
            }]"
          />
        </a-form-item>

        <div class="simiot-form-section-title">场景属性</div>

        <a-form-item label="通信制式">
          <a-select
            v-decorator="['comm_mode_id', {
              rules: [{ required: true, message: '请选择通信制式' }]
            }]"
            show-search
            option-filter-prop="children"
            placeholder="请选择"
            :loading="loadingCommModeOptions"
            allow-clear
          >
            <a-select-option
              v-for="opt in commModeOptions"
              :key="opt.id"
              :value="opt.id"
            >
              {{ opt.name }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item
          v-if="isAttrVisible('exceed_small_traffic_limit')"
          label="月用量可超300M"
        >
          <a-radio-group
            v-decorator="['exceed_small_traffic_limit', {
              rules: [{ required: true, message: '请选择月用量可超300M' }]
            }]"
          >
            <a-radio
              v-for="option in yesNoOptions"
              :key="'exceed_small_traffic_limit_' + option.value"
              :value="option.value"
            >
              {{ option.label }}
            </a-radio>
          </a-radio-group>
        </a-form-item>

        <a-form-item
          v-if="isAttrVisible('device_sim_unbind')"
          label="支持机卡分离解绑"
        >
          <a-radio-group
            v-decorator="['device_sim_unbind', {
              rules: [{ required: true, message: '请选择支持机卡分离解绑' }]
            }]"
          >
            <a-radio
              v-for="option in yesNoOptions"
              :key="'device_sim_unbind_' + option.value"
              :value="option.value"
            >
              {{ option.label }}
            </a-radio>
          </a-radio-group>
        </a-form-item>

        <a-form-item
          v-if="isAttrVisible('cross_province_no_lock')"
          label="支持跨省不锁卡"
        >
          <a-radio-group
            v-decorator="['cross_province_no_lock', {
              rules: [{ required: true, message: '请选择支持跨省不锁卡' }]
            }]"
          >
            <a-radio
              v-for="option in yesNoOptions"
              :key="'cross_province_no_lock_' + option.value"
              :value="option.value"
            >
              {{ option.label }}
            </a-radio>
          </a-radio-group>
        </a-form-item>

        <a-form-item
          v-if="isAttrVisible('sensitive_area_usage')"
          label="支持敏感地区使用"
        >
          <a-radio-group
            v-decorator="['sensitive_area_usage', {
              rules: [{ required: true, message: '请选择支持敏感地区使用' }]
            }]"
          >
            <a-radio
              v-for="option in yesNoOptions"
              :key="'sensitive_area_usage_' + option.value"
              :value="option.value"
            >
              {{ option.label }}
            </a-radio>
          </a-radio-group>
        </a-form-item>

        <a-form-item
          v-if="isAttrVisible('personal_real_name')"
          label="需要个人实名"
        >
          <a-radio-group
            v-decorator="['personal_real_name', {
              rules: [{ required: true, message: '请选择需要个人实名' }]
            }]"
          >
            <a-radio
              v-for="option in yesNoOptions"
              :key="'personal_real_name_' + option.value"
              :value="option.value"
            >
              {{ option.label }}
            </a-radio>
          </a-radio-group>
        </a-form-item>

        <a-form-item
          v-if="isAttrVisible('support_voice')"
          label="支持语音"
        >
          <a-radio-group
            v-decorator="['support_voice', {
              rules: [{ required: true, message: '请选择支持语音' }]
            }]"
          >
            <a-radio
              v-for="option in yesNoOptions"
              :key="'support_voice_' + option.value"
              :value="option.value"
            >
              {{ option.label }}
            </a-radio>
          </a-radio-group>
        </a-form-item>

        <a-form-item
          v-if="isAttrVisible('network_switch_mode')"
          label="切网模式"
        >
          <a-radio-group
            v-decorator="['network_switch_mode', {
              rules: [{ required: true, message: '请选择切网模式' }]
            }]"
          >
            <a-radio
              v-for="option in networkSwitchModeOptions"
              :key="'network_switch_mode_' + option.value"
              :value="option.value"
            >
              {{ option.label }}
            </a-radio>
          </a-radio-group>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { findCarrierTypeOptions } from '@/api/common_options'
import { findCommonTypeOptions } from '@/api/common_type'
import { findTrafficSceneForm, updateTrafficScene } from '@/api/traffic_scene'
import {
  TRAFFIC_SCENE_NETWORK_SWITCH_MODE_OPTIONS,
  clearHiddenTrafficSceneAttrs,
  isTrafficSceneAttrVisible,
  pickVisibleTrafficSceneAttrs
} from '@/utils/traffic_scene_attrs'

const YES_NO_OPTIONS = [
  { label: '是', value: true },
  { label: '否', value: false }
]

export default {
  name: 'EditTrafficScene',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'traffic_scene' }),
      submitting: false,
      carrierTypeOptions: findCarrierTypeOptions(),
      yesNoOptions: YES_NO_OPTIONS,
      networkSwitchModeOptions: TRAFFIC_SCENE_NETWORK_SWITCH_MODE_OPTIONS,
      selectedCarrierType: undefined,
      commModeOptions: [],
      loadingCommModeOptions: false
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  created() {
    this.fetchCommModeOptions().then(() => {
      this.fetchFormData()
    })
  },
  methods: {
    isAttrVisible(attr) {
      return isTrafficSceneAttrVisible(this.selectedCarrierType, attr)
    },

    handleCarrierTypeChange(carrierType) {
      this.selectedCarrierType = carrierType
      this.$nextTick(() => {
        clearHiddenTrafficSceneAttrs(this.form, carrierType)
      })
    },

    fetchCommModeOptions() {
      this.loadingCommModeOptions = true
      return findCommonTypeOptions('product_comm_mode').then((res) => {
        if (res.code === 0) {
          this.commModeOptions = res.data || []
        }
        this.loadingCommModeOptions = false
      }).catch(() => {
        this.loadingCommModeOptions = false
      })
    },

    fetchFormData() {
      findTrafficSceneForm(this.id).then((res) => {
        if (res.code === 0) {
          this.selectedCarrierType = res.data.carrier_type
          this.$nextTick(() => {
            this.form.setFieldsValue(res.data)
          })
        }
      })
    },

    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        this.$warning({
          title: '请勿重复提交',
          content: ''
        })
        return
      }

      this.form.validateFields((err, values) => {
        if (!err) {
          this.submitting = true
          updateTrafficScene(this.id, pickVisibleTrafficSceneAttrs(values)).then((res) => {
            if (res.code === 0) {
              this.isShow = false
              this.$emit('completed')
            }
            this.submitting = false
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.simiot-form-section-title {
  margin: 8px 0 16px;
  padding-left: 8px;
  color: rgba(0, 0, 0, 0.65);
  font-weight: 500;
  border-left: 3px solid #1890ff;
}
</style>
